// AdminDashboard.js - SON HAREKETLER DÜZELTİLMİŞ VERSİYON

import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../App';
import AdminTickets from './AdminTickets';
import AdminUsers from './AdminUsers';
import AdminInventory from './AdminInventory';
import AdminCountPeriod from './AdminCountPeriod';
import AdminCountResults from './AdminCountResults';
import AdminFaultReports from './AdminFaultReports';
import AdminChangeRequests from './AdminChangeRequests';
import Header from '../Header';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import AdminActivity from './AdminActivity';
Chart.register(ArcElement, Tooltip, Legend);


const AdminDashboard = ({ user, token, onNavigate }) => {
  const [stats, setStats] = useState({
    totalTickets: 0,
    openTickets: 0,
    totalUsers: 0,
    totalInventory: 0,
    faultReports: 0,
    changeRequests: 0
  });
  const [tickets, setTickets] = useState([]);
  const [users, setUsers] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('all');
  const [activityLog, setActivityLog] = useState([]);

  
  
  const fetchAdminData = async () => {
    setLoading(true);
    try {
      const headers = { 'Authorization': `Bearer ${token}` };
      const [ticketsRes, usersRes, inventoryRes, activityLogRes] = await Promise.all([
        fetch(`${API_BASE}/admin/tickets`, { headers }),
        fetch(`${API_BASE}/admin/users`, { headers }),
        fetch(`${API_BASE}/admin/inventory`, { headers }),
        fetch(`${API_BASE}/activity-logs`, { headers })
      ]);

      // Ticket verilerini işle
      if (ticketsRes.ok) {
        const ticketsData = await ticketsRes.json();
        setTickets(ticketsData);
        setStats(prev => ({
          ...prev,
          totalTickets: ticketsData.length,
          openTickets: ticketsData.filter(t => t.status === 'open' || t.status === 'in_progress').length,
          faultReports: ticketsData.filter(t => t.type === 'ariza').length,
          changeRequests: ticketsData.filter(t => t.type === 'degisim').length
        }));
      }

      // Kullanıcı verilerini işle
      if (usersRes.ok) {
        const usersData = await usersRes.json();
        setUsers(usersData);
        setStats(prev => ({ ...prev, totalUsers: usersData.length }));
      }

      

      // Envanter verilerini işle
      if (inventoryRes.ok) {
        const inventoryData = await inventoryRes.json();
        setInventory(inventoryData);
        setStats(prev => ({ ...prev, totalInventory: inventoryData.length }));
      }

      // ✅ DÜZELTME: Aktivite log verilerini işle
      if (activityLogRes.ok) {
        const logData = await activityLogRes.json();
        console.log('📊 Frontend aldığı aktivite verileri:', logData);
        setActivityLog(logData);
      } else {
        console.error('Aktivite logları yüklenemedi:', activityLogRes.statusText);
      }

    } catch (error) {
      console.error('❌ Admin data yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminData();
  }, []);

  const updateTicketStatus = async (ticketId, newStatus) => {
    const note = prompt("Durum güncellemesiyle ilgili not girin (isteğe bağlı):");
    try {
      const response = await fetch(`${API_BASE}/admin/tickets/${ticketId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status: newStatus, note })
      });
      
      if (response.ok) {
        fetchAdminData(); // Verileri yenile (aktivite logları da dahil)
      }
    } catch (error) {
      console.error('Ticket durumu güncellenirken hata:', error);
    }
  };

  const categoryPieData = React.useMemo(() => {
    if (!inventory || inventory.length === 0) return null;
    // Kategoriye göre ürün sayısını hesapla
    const categoryCounts = {};
    inventory.forEach(item => {
      const cat = item.category_name || 'Belirtilmemiş';
      categoryCounts[cat] = (categoryCounts[cat] || 0) + 1;
    });
    const labels = Object.keys(categoryCounts);
    const data = Object.values(categoryCounts);

    // Renk paleti (her kategoriye farklı renk)
    const colors = [
      '#dc2626', '#2563eb', '#059669', '#f59e42', '#a21caf', '#eab308', '#0ea5e9', '#d946ef', '#64748b', '#f43f5e'
    ];
    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: labels.map((_, i) => colors[i % colors.length]),
          borderWidth: 2,
          borderColor: '#fff'
        }
      ]
    };
  }, [inventory]);

  const statusPieData = React.useMemo(() => {
    if (!inventory || inventory.length === 0) return null;
    // Duruma göre ürün sayısını hesapla
    const statusCounts = {};
    inventory.forEach(item => {
      const status = item.status || 'Bilinmiyor';
      statusCounts[status] = (statusCounts[status] || 0) + 1;
    });
    const labels = Object.keys(statusCounts);
    const data = Object.values(statusCounts);

    // Renk paleti (her duruma farklı renk)
    const colors = [
      '#059669', // aktif
      '#f59e42', // bakımda
      '#dc2626', // arızalı
      '#2563eb', // stokta (yeni renk)
      '#64748b', // diğer
    ];
    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: labels.map((_, i) => colors[i % colors.length]),
          borderWidth: 2,
          borderColor: '#fff'
        }
      ]
    };
  }, [inventory]);

  const assignmentPieData = React.useMemo(() => {
    if (!inventory || inventory.length === 0) return null;
    let assigned = 0;
    let unassigned = 0;
    inventory.forEach(item => {
      if (item.assigned_user_email) {
        assigned += 1;
      } else {
        unassigned += 1;
      }
    });
    const labels = ['Atanmış', 'Boşta'];
    const data = [assigned, unassigned];
    const colors = ['#059669', '#dc2626'];
    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: colors,
          borderWidth: 2,
          borderColor: '#fff'
        }
      ]
    };
  }, [inventory]);

  // ✅ EKLEME: handleUsersUpdated fonksiyonu
  const handleUsersUpdated = () => {
    fetchAdminData(); // Tüm verileri yenile
  };

  const renderActiveContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardHome />;
      case 'inventory':
        return <AdminInventory users={users} />;
      case 'users':
        return <AdminUsers 
          onAddUser={handleUsersUpdated} 
          onUpdateUser={handleUsersUpdated} 
          onDeleteUser={handleUsersUpdated} 
        />;
      case 'activity': // ✅ EKLEME
        return <AdminActivity />;
      case 'tickets':
        return <AdminTickets />;
      default:
        return <DashboardHome />;
    }
  };

  if (loading) {
    return <div className="container"><div className="loading">Yükleniyor...</div></div>;
  }
  

  return (
    <div className="container">
      <div className="admin-dashboard">
        
        <h2 onClick={() => setActiveTab('overview')}
          style={{ cursor: 'pointer' }}
        >Yönetici Paneli</h2>
        <div className="admin-tabs">
            <button className={activeTab === 'overview' ? 'active' : ''} onClick={() => setActiveTab('overview')}>Genel Bakış</button>
            <button className={activeTab === 'tickets' ? 'active' : ''} onClick={() => setActiveTab('tickets')}>Tüm Talepler</button>
            <button className={activeTab === 'fault-reports' ? 'active' : ''} onClick={() => setActiveTab('fault-reports')}>Arıza Kayıtları</button>
            <button className={activeTab === 'change-requests' ? 'active' : ''} onClick={() => setActiveTab('change-requests')}>Değişim Talepleri</button>
            <button className={activeTab === 'users' ? 'active' : ''} onClick={() => setActiveTab('users')}>Kullanıcılar</button>
            <button className={activeTab === 'inventory' ? 'active' : ''} onClick={() => setActiveTab('inventory')}>Envanter</button>
            <button className={activeTab === 'count-period' ? 'active' : ''} onClick={() => setActiveTab('count-period')}>Sayım Periyodu</button>
            <button className={activeTab === 'count-results' ? 'active' : ''} onClick={() => setActiveTab('count-results')}>Sayım Sonuçları</button>
            <button className={activeTab === 'activity' ? 'active' : ''} onClick={() => setActiveTab('activity')}>Hareketler</button>
        </div>

        
        {activeTab === 'overview' && (
          <div className="admin-overview">
            <div className="stats-grid">
                <div className="stat-card" onClick={() => { setActiveTab('tickets'); setStatusFilter('all'); }}><h3>{stats.totalTickets}</h3><p>Toplam Talep</p></div>
                <div className="stat-card" onClick={() => { setActiveTab('tickets'); setStatusFilter('open'); }}><h3>{stats.openTickets}</h3><p>Açık Talep</p></div>
                <div className="stat-card fault-stat" onClick={() => setActiveTab('fault-reports')}><h3>{stats.faultReports}</h3><p>Arıza Kaydı</p></div>
                <div className="stat-card change-stat" onClick={() => setActiveTab('change-requests')}><h3>{stats.changeRequests}</h3><p>Değişim Talebi</p></div>
                <div className="stat-card" onClick={() => setActiveTab('users')}><h3>{stats.totalUsers}</h3><p>Toplam Kullanıcı</p></div>
                <div className="stat-card" onClick={() => setActiveTab('inventory')}><h3>{stats.totalInventory}</h3><p>Toplam Ürün</p></div>
            </div>
            
            {/* Pasta Grafik Alanları */}
            <div style={{ display: 'flex', gap: '2rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              {/* Kategoriye göre pasta grafik */}
              <div className="inventory-pie-chart-area">
                <h3>Envanter Kategori Dağılımı</h3>
                {categoryPieData ? (
                  <div style={{ maxWidth: 400, margin: '0 auto' }}>
                    <Pie data={categoryPieData} options={{
                      plugins: {
                        legend: { display: false }
                      }
                    }} />
                    <div className="pie-legend">
                      {categoryPieData.labels.map((cat, i) => (
                        <div key={cat} style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
                          <span style={{
                            display: 'inline-block',
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            background: categoryPieData.datasets[0].backgroundColor[i],
                            marginRight: 8,
                            border: '2px solid #fff'
                          }}></span>
                          <span style={{ fontWeight: 500 }}>{cat}</span>
                          <span style={{ marginLeft: 8, color: '#64748b' }}>({categoryPieData.datasets[0].data[i]})</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="no-data">Grafik için yeterli veri yok.</div>
                )}
              </div>

              {/* Duruma göre pasta grafik */}
              <div className="inventory-pie-chart-area">
                <h3>Ürün Durum Dağılımı</h3>
                {statusPieData ? (
                  <div style={{ maxWidth: 400, margin: '0 auto' }}>
                    <Pie data={statusPieData} options={{
                      plugins: {
                        legend: { display: false }
                      }
                    }} />
                    <div className="pie-legend">
                      {statusPieData.labels.map((status, i) => (
                        <div key={status} style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
                          <span style={{
                            display: 'inline-block',
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            background: statusPieData.datasets[0].backgroundColor[i],
                            marginRight: 8,
                            border: '2px solid #fff'
                          }}></span>
                          <span style={{ fontWeight: 500 }}>
                            {status === 'active' ? 'Aktif' :
                             status === 'maintenance' ? 'Bakımda' :
                             status === 'broken' ? 'Arızalı' :
                             status === 'stock' ? 'Stokta' : status}
                          </span>
                          <span style={{ marginLeft: 8, color: '#64748b' }}>({statusPieData.datasets[0].data[i]})</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="no-data">Grafik için yeterli veri yok.</div>
                )}
              </div>

              {/* Atanma durumuna göre pasta grafik */}
              <div className="inventory-pie-chart-area">
                <h3>Ürün Atanma Durumu</h3>
                {assignmentPieData ? (
                  <div style={{ maxWidth: 400, margin: '0 auto' }}>
                    <Pie data={assignmentPieData} options={{
                      plugins: {
                        legend: { display: false }
                      }
                    }} />
                    <div className="pie-legend">
                      {assignmentPieData.labels.map((label, i) => (
                        <div key={label} style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
                          <span style={{
                            display: 'inline-block',
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            background: assignmentPieData.datasets[0].backgroundColor[i],
                            marginRight: 8,
                            border: '2px solid #fff'
                          }}></span>
                          <span style={{ fontWeight: 500 }}>{label}</span>
                          <span style={{ marginLeft: 8, color: '#64748b' }}>({assignmentPieData.datasets[0].data[i]})</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="no-data">Grafik için yeterli veri yok.</div>
                )}
              </div>
            </div>

            
          </div>
        )}

        {/* Diğer tabların render edilmesi */}
        {activeTab === 'tickets' && (<AdminTickets tickets={tickets} users={users} onUpdateStatus={updateTicketStatus} statusFilter={statusFilter} setStatusFilter={setStatusFilter} />)}
        {activeTab === 'fault-reports' && (<AdminFaultReports tickets={tickets} users={users} onUpdateStatus={updateTicketStatus} />)}
        {activeTab === 'change-requests' && (<AdminChangeRequests tickets={tickets} users={users} onUpdateStatus={updateTicketStatus} />)}
        {activeTab === 'users' && (
          <AdminUsers 
            users={users} 
            onAddUser={fetchAdminData} // Callback ekle
            onUpdateUser={fetchAdminData} // Bu da eklensin
            onDeleteUser={fetchAdminData} // Bu da eklensin
          />
        )}
        {activeTab === 'inventory' && (
          <AdminInventory 
            inventory={inventory} 
            users={users} 
            onAddItem={fetchAdminData} 
            onUpdateItem={fetchAdminData} 
            onDeleteItem={fetchAdminData} 
          />
        )}
        {activeTab === 'count-period' && (<AdminCountPeriod token={token} />)}
        {activeTab === 'count-results' && (<AdminCountResults token={token} users={users} />)}
        {activeTab === 'activity' && <AdminActivity />}
      </div>
    </div>
  );
};

export default AdminDashboard;